import { Modal } from 'react-responsive-modal'
import {ReactComponent as RoundCloseIcon} from "../../assets/icons/x-round.svg";
import Warning from "../../assets/images/Warning.png";
import React from "react";

const styles = {
    modal: {
        overlay: {
            zIndex: '2000'
        },
        modal: {
            padding: 0,
            maxWidth: '526px',
            borderRadius: '20px',
        },
        closeButton: {
            right: '40px',
            top: '24px',
        }
    },
    yesButton: {
        width: '160px',
        height: '40px',
        backgroundColor: '#4290F3',
        borderRadius: '4px',
        color: 'white',
        display: 'block',
        margin: '0px auto'
    },
    noButton: {
        width: '160px',
        height: '40px',
        border: '1px solid #4290F3',
        borderRadius: '4px',
        color: '#4290F3',
        display: 'block',
        margin: '0px auto'
    },
    modalContainer: {
        marginTop: '50px',
        padding: '20px',
    },
    modalTitle: {
        fontWeight: '500',
        fontSize: '26px',
        lineHeight: '130%',
        textAlign: 'center',
        letterSpacing: '-0.03em',
        color: '#2C2543'
    },
    modalDescription: {
        fontStyle: 'normal',
        fontWeight: '300',
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'center',
        color: '#2C2543',
        margin: '20px 50px',
    },
    modalImage: {
        width: '100px',
        height: '100px',
        backgroundImage: `url(${Warning})`,
        backgroundSize: '50%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        margin: '25px auto'
    }
}

const DeleteConfirmationModal = ({ open, onClose }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            center
            styles={styles.modal}
            blockScroll={false}
            classNames={{
                modal: 'w-full',
                closeButton: 'outline-none'
            }}
            closeIcon={(
                <span style={{ width: '34px', height: '34px' }}>
                  <RoundCloseIcon />
                </span>
            )}
        >
            <div style={styles.modalContainer}>
                <div style={styles.modalImage}></div>
                <h2 style={styles.modalTitle}>Are You sure you want to delete this Timestamp?</h2>
                <div className="flex flex-wrap" style={{marginTop: '50px'}}>
                    <button style={styles.yesButton} onClick={() => onClose(true)}>Yes</button>
                    <button style={styles.noButton} onClick={() => onClose()}>No</button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteConfirmationModal
